module.exports = __webpack_public_path__ + "static/tu-wien-logo-6c19842b1ad75982f5518e7ad05b5ba0.png";